/** Petites fonctions couleur pour dériver des teintes à partir des couleurs de catégorie. */

export const hexToRgb = hex => {
  const clean = String(hex).replace("#", "");
  const full = clean.length === 3 ? clean.split("").map(c => c + c).join("") : clean;
  const n = parseInt(full, 16);
  return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
};

const clamp = v => Math.max(0, Math.min(255, Math.round(v)));

export const rgbToHex = ({ r, g, b }) => `#${[r, g, b].map(v => clamp(v).toString(16).padStart(2, "0")).join("")}`;

/** Mélange `a` vers `b` selon `t` (0 → a, 1 → b). */
export const mix = (a, b, t) => {
  const ca = hexToRgb(a);
  const cb = hexToRgb(b);
  return rgbToHex({ r: ca.r + (cb.r - ca.r) * t, g: ca.g + (cb.g - ca.g) * t, b: ca.b + (cb.b - ca.b) * t });
};

/** Assombrit (t < 0) ou éclaircit (t > 0) une couleur. */
export const shade = (hex, t) => mix(hex, t < 0 ? "#000000" : "#ffffff", Math.abs(t));

export const hexToRgba = (hex, alpha) => {
  const { r, g, b } = hexToRgb(hex);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
